import { JurisdictionsEnum } from '@libs/backend-common';
import { Environment } from '@libs/types';
const prId = process.env.PR_ID || '';
const urlsObject = {
    crexone: {
        dev: {
            landing: 'https://crexone-landing-dev-graphql.kube.bitnet.ge',
            web: 'https://crexone-web-dev-graphql.kube.bitnet.ge',
        },
        prod: {
            landing: 'https://crexone.io',
            web: 'https://app.crexone.io',
        },
        testing: {
            landing: `https://crexone-landing-${prId}.testing.bitnet.ge`,
            web: `https://crexone-web-${prId}.testing.bitnet.ge`,
        },
    },
    bitnet: {
        dev: {
            landing: 'https://bitnet-landing-dev-graphql.kube.bitnet.ge',
            web: 'https://bitnet-web-dev-graphql.kube.bitnet.ge',
        },
        prod: {
            landing: 'https://bitnet.ge',
            web: 'https://app.bitnet.ge',
        },
        testing: {
            landing: `https://bitnet-landing-${prId}.testing.bitnet.ge`,
            web: `https://bitnet-web-${prId}.testing.bitnet.ge`,
        },
    },
    xbitnet: {
        dev: {
            landing: 'https://xbitnet-landing-dev-graphql.kube.bitnet.ge',
            web: 'https://xbitnet-web-dev-graphql.kube.bitnet.ge',
        },
        prod: {
            landing: 'https://bitnet.trade',
            web: 'https://app.bitnet.trade',
        },
        testing: {
            landing: `https://xbitnet-landing-${prId}.testing.bitnet.ge`,
            web: `https://xbitnet-web-${prId}.testing.bitnet.ge`,
        },
    },
};
export const getJurisdictionBaseUrl = (env) => {
    const isGlobalCrexone = window.location.host.includes('crexone');
    const isGlobalXbitnet = window.location.host.includes('bitnet.trade') ||
        window.location.host.includes('xbitnet');
    const isGlobal = isGlobalCrexone || isGlobalXbitnet;
    let platformUrlObject;
    if (isGlobalCrexone) {
        platformUrlObject = urlsObject.crexone;
    }
    else if (isGlobalXbitnet) {
        platformUrlObject = urlsObject.xbitnet;
    }
    else {
        platformUrlObject = urlsObject.bitnet;
    }
    let landingUrl = platformUrlObject.prod.landing;
    let dashboardUrl = platformUrlObject.prod.web;
    if (env === Environment.dev) {
        landingUrl = platformUrlObject.dev.landing;
        dashboardUrl = platformUrlObject.dev.web;
    }
    if (env === Environment.testing) {
        landingUrl = platformUrlObject.testing.landing;
        dashboardUrl = platformUrlObject.testing.web;
    }
    let jurisdictionId = JurisdictionsEnum.GE;
    if (isGlobalXbitnet) {
        jurisdictionId = JurisdictionsEnum.EU;
    }
    else if (isGlobalCrexone) {
        jurisdictionId = JurisdictionsEnum.UA;
    }
    return {
        isGlobal,
        landingUrl,
        dashboardUrl,
        jurisdictionId,
    };
};
//# sourceMappingURL=jurisdiction.js.map